/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoyaltyProgrammeAccount } from './LoyaltyProgrammeAccount';
import {
    LoyaltyProgrammeAccountFromJSON,
    LoyaltyProgrammeAccountFromJSONTyped,
    LoyaltyProgrammeAccountToJSON,
    LoyaltyProgrammeAccountToJSONTyped,
} from './LoyaltyProgrammeAccount';

/**
 * A passenger specified by their fare type
 * @export
 * @interface OfferRequestPassengerWithFareType
 */
export interface OfferRequestPassengerWithFareType {
    /**
     * The age of the passenger on the `departure_date` of the final slice
     * @type {number}
     * @memberof OfferRequestPassengerWithFareType
     */
    age?: number | null;
    /**
     * The passenger's family name. Only `space`, `-`, `'`, and letters from the [`ASCII`](https://www.unicode.org/charts/PDF/U0000.pdf), [`Latin-1 Supplement`](https://www.unicode.org/charts/PDF/U0080.pdf) and [`Latin Extended-A`](https://www.unicode.org/charts/PDF/U0100.pdf) (with the exceptions of `Æ`, `æ`, `Ĳ`, `ĳ`, `Œ`, `œ`, `Þ`, and `ð`) Unicode charts are accepted. All other characters will result in a validation error. The minimum length is 1 character, and the maximum is 20 characters.
     * 
     * This is only required if you're also including loyalty programme accounts.
     * 
     * @type {string}
     * @memberof OfferRequestPassengerWithFareType
     */
    familyName?: string | null;
    /**
     * The fare type of the passenger
     * @type {string}
     * @memberof OfferRequestPassengerWithFareType
     */
    fareType?: string;
    /**
     * The passenger's given name. Only `space`, `-`, `'`, and letters from the [`ASCII`](https://www.unicode.org/charts/PDF/U0000.pdf), [`Latin-1 Supplement`](https://www.unicode.org/charts/PDF/U0080.pdf) and [`Latin Extended-A`](https://www.unicode.org/charts/PDF/U0100.pdf) (with the exceptions of `Æ`, `æ`, `Ĳ`, `ĳ`, `Œ`, `œ`, `Þ`, and `ð`) Unicode charts are accepted. All other characters will result in a validation error. The minimum length is 1 character, and the maximum is 20 characters.
     * 
     * This is only required if you're also including loyalty programme accounts.
     * 
     * @type {string}
     * @memberof OfferRequestPassengerWithFareType
     */
    givenName?: string | null;
    /**
     * The identifier for the passenger, unique within this Offer Request and across all Offer Requests. This ID will be generated by Duffel. Optionally providing an ID has been deprecated.
     * @type {string}
     * @memberof OfferRequestPassengerWithFareType
     */
    id?: string;
    /**
     * The loyalty programme accounts for this passenger
     * @type {Array<LoyaltyProgrammeAccount>}
     * @memberof OfferRequestPassengerWithFareType
     */
    loyaltyProgrammeAccounts?: Array<LoyaltyProgrammeAccount>;
    /**
     * The type of the passenger
     * @type {string}
     * @memberof OfferRequestPassengerWithFareType
     */
    type?: OfferRequestPassengerWithFareTypeTypeEnum | null;
}


/**
 * @export
 */
export const OfferRequestPassengerWithFareTypeTypeEnum = {
    Adult: 'adult',
    Child: 'child',
    InfantWithoutSeat: 'infant_without_seat'
} as const;
export type OfferRequestPassengerWithFareTypeTypeEnum = typeof OfferRequestPassengerWithFareTypeTypeEnum[keyof typeof OfferRequestPassengerWithFareTypeTypeEnum];


/**
 * Check if a given object implements the OfferRequestPassengerWithFareType interface.
 */
export function instanceOfOfferRequestPassengerWithFareType(value: object): value is OfferRequestPassengerWithFareType {
    return true;
}

export function OfferRequestPassengerWithFareTypeFromJSON(json: any): OfferRequestPassengerWithFareType {
    return OfferRequestPassengerWithFareTypeFromJSONTyped(json, false);
}

export function OfferRequestPassengerWithFareTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferRequestPassengerWithFareType {
    if (json == null) {
        return json;
    }
    return {
        
        'age': json['age'] == null ? undefined : json['age'],
        'familyName': json['family_name'] == null ? undefined : json['family_name'],
        'fareType': json['fare_type'] == null ? undefined : json['fare_type'],
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'id': json['id'] == null ? undefined : json['id'],
        'loyaltyProgrammeAccounts': json['loyalty_programme_accounts'] == null ? undefined : ((json['loyalty_programme_accounts'] as Array<any>).map(LoyaltyProgrammeAccountFromJSON)),
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function OfferRequestPassengerWithFareTypeToJSON(json: any): OfferRequestPassengerWithFareType {
    return OfferRequestPassengerWithFareTypeToJSONTyped(json, false);
}

export function OfferRequestPassengerWithFareTypeToJSONTyped(value?: OfferRequestPassengerWithFareType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'age': value['age'],
        'family_name': value['familyName'],
        'fare_type': value['fareType'],
        'given_name': value['givenName'],
        'id': value['id'],
        'loyalty_programme_accounts': value['loyaltyProgrammeAccounts'] == null ? undefined : ((value['loyaltyProgrammeAccounts'] as Array<any>).map(LoyaltyProgrammeAccountToJSON)),
        'type': value['type'],
    };
}

